<template>
  <div
    ref="control"
    :class="[
      'control',
      { error: error && error.length },
      { success: valid && error && !error.length }
    ]"
  >
    <div class="control-wrap">
      <the-mask
        v-model="val"
        @input.native="input"
        @blur.native="blur"
        ref="input"
        :name="name"
        :type="type ? type : 'text'"
        :id="id"
        autocomplete="off"
        :class="['control-input', { 'has-icon': icon }]"
        :placeholder="label"
        :pattern="pattern"
        :mask="mask"
        :v-validate="validate"
        :disabled="disabled"
      ></the-mask>
      <font-awesome-icon class="control-icon control-icon--left" v-if="icon" :icon="icon" />
    </div>

    <p class="control-error" v-for="(err, $index) in error" :key="$index">{{ err }}</p>
  </div>
</template>

<script>
import { TheMask } from 'vue-the-mask';
import masker from 'vue-the-mask/src/masker';
import tokens from 'vue-the-mask/src/tokens';

const createmask = (value, mask) => masker(value, mask, true, tokens);

export default {
  name: 'FormControlMask',
  data() {
    return {
      states: {},
      val: null
    };
  },
  $_veeValidate: {
    value() {
      return this.val;
    },
    name() {
      return this.name;
    }
  },
  watch: {
    value(newVal) {
      this.$refs.input.$el.value = createmask(newVal, this.mask);
      this.val = newVal;

      const field = this.$parent.$validator.fields.find({ name: this.name });
      if (field) {
        field.setFlags({ dirty: true });
        this.$parent.$validator.validate(this.name);
      }
    }
  },
  props: [
    'label',
    'id',
    'type',
    'error',
    'value',
    'mask',
    'name',
    'masked',
    'icon',
    'validate',
    'pattern',
    'valid',
    'disabled'
  ],
  components: {
    TheMask
  },
  methods: {
    input() {
      const { display, lastValue } = this.$refs.input;

      if (this.masked) {
        this.$emit('input', display);
      } else {
        this.$emit('input', lastValue);
      }
    },
    blur() {
      if (this.masked) {
        this.$emit('blur', this.$refs.input.display);
      } else {
        this.$emit('blur', this.$refs.input.lastValue);
      }
    }
  }
};
</script>
